import { render, staticRenderFns } from "./SoleProprietorshipDetails.vue?vue&type=template&id=6ffea32e&scoped=true"
import script from "./SoleProprietorshipDetails.vue?vue&type=script&lang=js"
export * from "./SoleProprietorshipDetails.vue?vue&type=script&lang=js"
import style0 from "./SoleProprietorshipDetails.vue?vue&type=style&index=0&id=6ffea32e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffea32e",
  null
  
)

export default component.exports